import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentEditable from 'react-contenteditable';
import {
    WysiwygEditor,
} from '../../theme/components';
import Style from './style';

class ComposeReportEditor extends Component {
    constructor() {
        super();
        this.contentEditable = React.createRef();
        this.state = { html: '' };
    }

    componentDidMount() {
        const { section } = this.props;
        this.setState({ html: section.content });
    }

    handleChange = (e) => {
        const { section, editSection } = this.props;
        this.setState({ html: e.target.value });
        editSection({ slug: section.slug, content: e.target.value });
    };

    render() {
        const { html } = this.state;
        return (
            <Style>
                <WysiwygEditor>
                    <ContentEditable
                        innerRef={this.contentEditable}
                        html={html}
                        disabled={false}
                        onChange={this.handleChange}
                    />
                </WysiwygEditor>
            </Style>
        );
    }
}

ComposeReportEditor.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    section: PropTypes.object,
    editSection: PropTypes.func,
};

ComposeReportEditor.defaultProps = {
    section: { slug: '', content: '' },
    editSection: () => {},
};

export default ComposeReportEditor;
